module.exports = __webpack_public_path__ + "img/ROU.d87ef8c6.svg";